import styles from "@fwa/src/components/HomePageImpactMoney/styles.module.css";

export function HomePageImpactMoney({
  selectedNumber,
}: {
  selectedNumber: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}) {
  return (
    <div
      className={styles["number-bubble-wrapper"]}
      data-selected-item={selectedNumber}
    >
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 1}
      >
        £100
      </div>
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 2}
      >
        £250
      </div>
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 3}
      >
        £500
      </div>
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 4}
      >
        £1,000
      </div>
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 5}
      >
        £2,500
      </div>
      <div
        className={styles["number-bubble"]}
        data-is-active={selectedNumber === 6}
      >
        £5,000
      </div>
    </div>
  );
}

export default HomePageImpactMoney;
